module.exports = __webpack_public_path__ + "img/fondo-banner-principal.739ffd45.png";